
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logout/success",
      function () {
        return require("private-next-pages/logout/success.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logout/success"])
      });
    }
  